export const CREATE_WEET_VIEW_SESSION = 'CREATE_WEET_VIEW_SESSION';
export const STOP_WEET_VIEW_SESSION = 'STOP_WEET_VIEW_SESSION';
export const ADD_EVENT_TO_WEET_VIEW_SESSION = 'ADD_EVENT_TO_WEET_VIEW_SESSION';
export const LOAD_LAST_WEET_VIEWERS = 'LOAD_LAST_WEET_VIEWERS';



